
// generated with scripts/generate_build_environment.sh
export const buildEnv = {
  projectName: 't-online',
  buildVersion: '120e3aa9',
  buildTimestamp: '2026-07-29T10:21:46+0000',
  customCss: 'assets/projects/t-online/custom.css?version=120e3aa9',
  customJs: ''
};
